import {
  Dashboard as DashboardIcon,
  Event as EventIcon,
  Build as BuildIcon,
  ContentCut as ContentCutIcon,
  Inventory2 as Inventory2Icon,
  People as PeopleIcon,
  Person as PersonIcon,
  Store as StoreIcon,
  AddBusiness as AddBusinessIcon,
  CreditCard as CreditCardIcon,
  CardMembership as CardMembershipIcon,
  Settings as SettingsIcon,
  Payments as PaymentsIcon,
  Tune as TuneIcon,
  MonitorHeart as MonitorHeartIcon,
  LocalOffer as LocalOfferIcon,
  FaceRetouchingNatural as FaceRetouchingNaturalIcon,
  Groups as GroupsIcon,
  AccountBalance as AccountBalanceIcon,
  EditNotifications as EditNotificationsIcon,
  CloudUpload as CloudUploadIcon,
  Chat as ChatIcon,
  Queue as QueueIcon,
  Warehouse as WarehouseIcon,
  ReceiptLong as ReceiptLongIcon,
} from '@mui/icons-material';

const iconMap = {
  Dashboard: DashboardIcon,
  Event: EventIcon,
  Build: BuildIcon,
  ContentCut: ContentCutIcon,
  Inventory2: Inventory2Icon,
  People: PeopleIcon,
  Person: PersonIcon,
  Store: StoreIcon,
  AddBusiness: AddBusinessIcon,
  CreditCard: CreditCardIcon,
  CardMembership: CardMembershipIcon,
  Settings: SettingsIcon,
  Payments: PaymentsIcon,
  Tune: TuneIcon,
  MonitorHeart: MonitorHeartIcon,
  LocalOffer: LocalOfferIcon,
  FaceRetouchingNatural: FaceRetouchingNaturalIcon,
  Groups: GroupsIcon,
  AccountBalance: AccountBalanceIcon,
  EditNotifications: EditNotificationsIcon,
  CloudUpload: CloudUploadIcon,
  Chat: ChatIcon,
  Queue: QueueIcon,
  Warehouse: WarehouseIcon,
  ReceiptLong: ReceiptLongIcon,
};

export const getIconComponent = (iconName) => {
  return iconMap[iconName] || SettingsIcon;
};
